module.exports = __webpack_public_path__ + "static/img/top.86d4f2d6.jpg";